<template>
  <el-radio-group v-model="selectIndex" size="mini">
    <el-radio-button
      v-for="(option,index) in  selectList"
      :key="'option'+index"
      :value="parseInt(index,10)"
      :label="index"
      >{{option}}</el-radio-button>
  </el-radio-group>
</template>
<script>
export default {
  name: 'select-options-nav',
  props: {
    selectOption: {
      default: 0,
      type: Number,
    },
    selectList: {
      type: Array,
      default() {
        return ['环境', '视频'];
      },
    },
  },
  data() {
    return {
      selectIndex: 0,
    };
  },
  mounted() {
    this.selectIndex = this.selectOption;
  },
  watch: {
    selectOption(newVal) {
      this.selectIndex = newVal;
    },
    selectIndex(newVal) {
      this.$emit('selectOption', newVal);
    },
  },
};
</script>
<style scoped>
.select-options-nav {
  font-size: 1.4rem;
  color: #409EFF;
  border: solid 2px #409EFF;
  border-radius: 1.2rem;
  z-index: 99;
  background-color: rgba(160,207,255);
  padding:0 10px;
}
.selected-option {
  color: white;
}
.select-option + .select-option:before {
  content: "|";
  width: 50px;
  height: 20px;
  color: white;
}
</style>
